import { Component, Inject, LOCALE_ID, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { filter, map } from 'rxjs/operators';

import { DOCUMENT } from '@angular/common';
import { Platform } from '@angular/cdk/platform';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Settings } from 'luxon';
import { ConfigService } from '@vex/services/config.service';
import { SplashScreenService } from '@vex/services/splash-screen.service';
import { Style, StyleService } from '@vex/services/style.service';
import { ConfigName } from '@vex/interfaces/config-name.model';
import { AuthService } from '@vex/http-service/auth.service';
import { SyncService } from '@vex/http-service/sync.service';
@Component({
  selector: 'vex-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'vex';
 
  // splashScreenService first time project load loader
  constructor(
    private configService: ConfigService,
    private styleService: StyleService,
    private renderer: Renderer2,
    private platform: Platform,
    @Inject(DOCUMENT) private document: Document,
    @Inject(LOCALE_ID) private localeId: string,
    private route: ActivatedRoute,
    private splashScreenService: SplashScreenService,
    private authService: AuthService,
    private syncService: SyncService) {

    Settings.defaultLocale = this.localeId;

    if (this.platform.BLINK) {
      this.renderer.addClass(this.document.body, 'is-blink');
    }

    this.route.queryParamMap.pipe(
      map(queryParamMap => queryParamMap.has('rtl') && coerceBooleanProperty(queryParamMap.get('rtl'))),
    ).subscribe(isRtl => {
      this.document.body.dir = isRtl ? 'rtl' : 'ltr';
      this.configService.updateConfig({
        rtl: isRtl
      });
    });

    this.route.queryParamMap.pipe(
      filter(queryParamMap => queryParamMap.has('layout'))
    ).subscribe(queryParamMap => this.configService.setConfig(queryParamMap.get('layout') as ConfigName));

    this.route.queryParamMap.pipe(
      filter(queryParamMap => queryParamMap.has('style'))
    ).subscribe(queryParamMap => this.styleService.setStyle(queryParamMap.get('style') as Style));
  }

  /**
   * Recovers interrupted shared-cache work as soon as any tab opens with the
   * browser's persisted session, independently of the route/layout lifecycle.
   */
  ngOnInit(): void {
    if (this.authService.hasPersistedSession()) {
      this.syncService.resumeOnApplicationStart().catch(error =>
        console.warn('Platform data startup recovery could not complete.', error));
    }
  }
}
